if (!customElements.get('collection-search-box')) {
  class CollectionSearchBox extends SearchForm {
    constructor() {
      super();
      this.statusElement = this.querySelector('[data-collection-search-status]');
      this.collectionUrl = this.getAttribute('data-collection-url');
      this.noResultsText = this.getAttribute('data-no-results-text') || '';
      this.loadingText = this.getAttribute('data-loading-text') || '';
      this.resultsCountSuffix = this.getAttribute('data-results-count-suffix') || '';
      this.pageWidthClass = this.getAttribute('data-page-width-class') || '';
      this.gridContainer = document.getElementById(this.getAttribute('data-grid-target'));
      this.filtersContainer = document.getElementById(this.getAttribute('data-filters-target'));
      this.resultsContainer = document.getElementById(this.getAttribute('data-results-target'));

      if (this.resultsContainer && this.pageWidthClass) {
        this.resultsContainer.classList.add(this.pageWidthClass);
      }

      this.products = [];
      this.indexLoaded = false;
      this.indexRequested = false;

      if (this.input && this.input.form) {
        this.input.form.addEventListener('submit', (event) => event.preventDefault());
      }
      if (this.input) {
        this.input.addEventListener('focus', () => this.ensureIndexLoaded(), { once: true });
      }
    }

    ensureIndexLoaded() {
      if (this.indexRequested) return;
      this.indexRequested = true;
      this.loadIndex();
    }

    async loadIndex() {
      if (!this.collectionUrl) return;

      const firstPage = await this.fetchIndexPage(1);
      if (!firstPage) {
        this.indexLoaded = true;
        return;
      }

      this.products = this.products.concat(firstPage.products);
      const totalPages = firstPage.pages || 1;

      if (totalPages > 1) {
        const pageNumbers = Array.from({ length: totalPages - 1 }, (_, index) => index + 2);
        const remainingPages = await Promise.all(pageNumbers.map((page) => this.fetchIndexPage(page)));
        remainingPages.forEach((page) => {
          if (page) this.products = this.products.concat(page.products);
        });
      }

      this.indexLoaded = true;

      if (this.getQuery()) this.renderResults(this.getQuery());
    }

    async fetchIndexPage(page) {
      try {
        const url = `${this.collectionUrl}?section_id=collection-search-index&page=${page}`;
        const response = await fetch(url);
        if (!response.ok) return null;
        const text = await response.text();
        const match = text.match(/<script[^>]*data-collection-search-index[^>]*>([\s\S]*?)<\/script>/);
        return match ? JSON.parse(match[1]) : null;
      } catch (error) {
        return null;
      }
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      super.onChange();
      const term = this.getQuery();

      if (!term.length) {
        this.showOriginalGrid();
        return;
      }

      this.ensureIndexLoaded();
      this.renderResults(term);
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (!this.getQuery()) {
        this.showOriginalGrid();
      }
    }

    renderResults(term) {
      if (!this.resultsContainer) return;

      const needle = term.toLowerCase();
      const matches = this.products.filter((product) => product.title.toLowerCase().includes(needle));

      this.showSearchResults();

      if (matches.length === 0 && !this.indexLoaded) {
        this.setMessage(this.loadingText);
        return;
      }

      if (matches.length === 0) {
        this.setMessage(this.noResultsText);
        return;
      }

      const fragment = document.createDocumentFragment();
      matches.forEach((product) => fragment.appendChild(this.renderCard(product)));
      this.resultsContainer.innerHTML = '';
      this.resultsContainer.appendChild(fragment);

      if (this.statusElement) {
        this.statusElement.textContent = `${matches.length}${this.resultsCountSuffix}`;
      }
    }

    renderCard(product) {
      const item = document.createElement('li');
      item.className = 'grid__item collection-search-result';

      const link = document.createElement('a');
      link.href = product.url;
      link.className = 'collection-search-result__link';

      const image = document.createElement('img');
      image.src = product.image || '';
      image.width = 300;
      image.height = 300;
      image.loading = 'lazy';
      image.alt = '';
      link.appendChild(image);

      const name = document.createElement('p');
      name.className = 'collection-search-result__title';
      name.textContent = product.title;
      link.appendChild(name);

      const info = document.createElement('div');
      info.className = 'collection-search-result__info';

      const price = document.createElement('span');
      price.className = 'price';
      price.textContent = product.price;
      info.appendChild(price);

      if (!product.available) {
        const sold = document.createElement('span');
        sold.className = 'collection-search-result__sold-out';
        sold.textContent = 'SOLD OUT';
        info.appendChild(sold);
      }

      link.appendChild(info);
      item.appendChild(link);
      return item;
    }

    setMessage(text) {
      const item = document.createElement('li');
      item.className = 'collection-search-result__message';

      const message = document.createElement('p');
      message.className = 'collection-search__message';
      message.textContent = text;
      item.appendChild(message);

      this.resultsContainer.innerHTML = '';
      this.resultsContainer.appendChild(item);
      if (this.statusElement) this.statusElement.textContent = '';
    }

    showSearchResults() {
      if (this.gridContainer) this.gridContainer.hidden = true;
      if (this.filtersContainer) this.filtersContainer.hidden = true;
      if (this.resultsContainer) this.resultsContainer.hidden = false;
    }

    showOriginalGrid() {
      if (this.gridContainer) this.gridContainer.hidden = false;
      if (this.filtersContainer) this.filtersContainer.hidden = false;
      if (this.resultsContainer) {
        this.resultsContainer.hidden = true;
        this.resultsContainer.innerHTML = '';
      }
      if (this.statusElement) this.statusElement.textContent = '';
    }
  }

  customElements.define('collection-search-box', CollectionSearchBox);
}
